import { useState } from 'react';
import { D, st, toArr } from '../constants';
import { Overlay, MHdr, Field } from './shared';

const FREQUENCIES = ['Weekly','Monthly','Quarterly','Yearly'];
const CATEGORIES = ['Insurance','Rent/Lease','Utilities','Vehicle','Subscription','Loan Payment','Equipment','Other'];

const monthlyAmount = r => {
  const amt = Number(r.amount) || 0;
  switch (r.frequency) {
    case 'Weekly': return amt * 4.33;
    case 'Quarterly': return amt / 3;
    case 'Yearly': return amt / 12;
    default: return amt;
  }
};

export default function Recurring({recurring, apiSaveRecurring, apiDeleteRecurring, apiToggleRecurring, fmt, me}) {
  const isOwner = me?.user?.role === 'owner';
  const [modal, setModal] = useState(null);
  const [saving, setSaving] = useState(false);

  const items = toArr(recurring);
  const activeItems = items.filter(r => r.active);
  const monthlyTotal = activeItems.reduce((s,r)=>s+monthlyAmount(r),0);

  const openNew = () => setModal({description:'', vendor:'', category:CATEGORIES[0], amount:'', frequency:'Monthly', dueDay:1});
  const openEdit = r => setModal({...r});

  const save = async () => {
    if (!modal.description.trim()) return;
    setSaving(true);
    try {
      await apiSaveRecurring({...modal, amount:Number(modal.amount)||0, dueDay:Number(modal.dueDay)||1});
      setModal(null);
    } catch(e) { alert("Failed to save: "+e.message); }
    setSaving(false);
  };

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:8}}>
        <div style={st.h1}>Recurring Expenses</div>
        <button style={st.btn("primary")} onClick={openNew}>+ Add Recurring</button>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:14,marginBottom:20}}>
        <div style={st.card}>
          <div style={{fontSize:11,color:D.muted,marginBottom:6}}>Active Items</div>
          <div style={{fontSize:22,fontWeight:600}}>{activeItems.length}</div>
        </div>
        <div style={st.card}>
          <div style={{fontSize:11,color:D.muted,marginBottom:6}}>Estimated Monthly Total</div>
          <div style={{fontSize:22,fontWeight:600,color:D.accent}}>{fmt(monthlyTotal)}</div>
        </div>
      </div>

      <div style={st.card}>
        <div style={{overflowX:"auto"}}><table style={st.table}>
          <thead><tr>{["Description","Vendor","Category","Amount","Frequency","Due Day","Active",""].map(h=><th key={h} style={st.th}>{h}</th>)}</tr></thead>
          <tbody>
            {items.map(r=>(
              <tr key={r.id} style={{opacity:r.active?1:0.5}}>
                <td style={st.td}>{r.description||'-'}</td>
                <td style={st.td}>{r.vendor||'-'}</td>
                <td style={st.td}>{r.category||'-'}</td>
                <td style={st.td}>{fmt(r.amount)}</td>
                <td style={st.td}>{r.frequency}</td>
                <td style={st.td}>{r.dueDay}</td>
                <td style={st.td}>
                  <input type="checkbox" checked={!!r.active} onChange={()=>apiToggleRecurring(r)} style={{accentColor:D.accent,cursor:"pointer"}}/>
                </td>
                <td style={st.td}>
                  <div style={{display:"flex",gap:6}}>
                    <button style={{...st.btn(),fontSize:11,padding:'2px 8px'}} onClick={()=>openEdit(r)}>Edit</button>
                    {isOwner && <button style={{...st.btn('danger'),fontSize:11,padding:'2px 8px'}} onClick={()=>{if(confirm('Delete this recurring item?'))apiDeleteRecurring(r.id);}}>Delete</button>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table></div>
        {items.length===0 && <div style={{padding:"30px 0",textAlign:"center",color:D.muted,fontSize:13}}>No recurring expenses yet.</div>}
      </div>

      {modal && <Overlay><div style={{background:D.card,border:`1px solid ${D.border}`,borderRadius:12,padding:24,width:"min(480px,95vw)"}}>
        <MHdr title={modal.id?"Edit Recurring Expense":"New Recurring Expense"} onClose={()=>setModal(null)}/>
        <Field label="Description"><input style={st.input} value={modal.description} onChange={e=>setModal(m=>({...m,description:e.target.value}))}/></Field>
        <Field label="Vendor"><input style={st.input} value={modal.vendor||''} onChange={e=>setModal(m=>({...m,vendor:e.target.value}))}/></Field>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
          <Field label="Category">
            <select style={st.input} value={modal.category} onChange={e=>setModal(m=>({...m,category:e.target.value}))}>
              {CATEGORIES.map(c=><option key={c}>{c}</option>)}
            </select>
          </Field>
          <Field label="Amount ($)"><input type="number" min="0" step="0.01" style={st.input} value={modal.amount} onChange={e=>setModal(m=>({...m,amount:e.target.value}))}/></Field>
          <Field label="Frequency">
            <select style={st.input} value={modal.frequency} onChange={e=>setModal(m=>({...m,frequency:e.target.value}))}>
              {FREQUENCIES.map(f=><option key={f}>{f}</option>)}
            </select>
          </Field>
          <Field label="Due Day (1-31)"><input type="number" min="1" max="31" style={st.input} value={modal.dueDay} onChange={e=>setModal(m=>({...m,dueDay:e.target.value}))}/></Field>
        </div>
        <div style={{display:"flex",justifyContent:"flex-end",gap:8,marginTop:16}}>
          <button style={st.btn()} onClick={()=>setModal(null)}>Cancel</button>
          <button style={st.btn("primary")} disabled={saving||!modal.description.trim()} onClick={save}>{saving?'Saving...':'Save'}</button>
        </div>
      </div></Overlay>}
    </div>
  );
}
